import React from 'react'

const Tools = () => {
  return (
    <div className="sklls__content">
        <h3 className="skills__titlle">Tools</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">React</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Node</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Pandas</h3>
                    <span className="skills__level">Basic</span>
                </div>

                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">VS Code</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Git/Github</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>

                <div className="skills__data">
                <i class='bx bx-check-circle'></i>

                <div>
                    <h3 className="skills__name">Figma</h3>
                    <span className="skills__level">Basics</span>
                </div>

                </div>
            </div>
        </div>
    </div>
  )
}

export default Tools
